import { render, staticRenderFns } from "./empty-search.vue?vue&type=template&id=59a90d1f&functional=true&"
var script = {}
import style0 from "./empty-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports